import Vue from "vue";
import Router from "vue-router";
import home from "@/components/home";
import learnerType from "@/components/learner-type-quiz";
import fusionQuiz from "@/components/fusion-superhero-type-quiz";
import fusionImagineerQuiz from "@/components/fusion-imagineer-type-quiz";
import fusionResiliencyQuiz from "@/components/resiliency-quiz-type";
import sparkingChangeQuiz from "../components/sparking-change-quiz";
import fusionAnimalQuiz from "@/components/fusion-canadian-animal-type-quiz";
import eventQuizContainer from '@/components/event-quiz-container';
import eventQuizResults from '@/components/event-quiz-results';
import eventQR from '@/components/event-qr';
import pdReadinessQuiz from "../components/pd-readiness-quiz.vue";
import eduPdReadinessQuiz from "../components/pd-readiness-quiz-edu.vue"


Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'Home',
      component: home,
      meta: { version: 1 }
    },
    {
      path: '/professional-learning-readiness-edu',
      name: 'Education Association Professional Learning Readiness Checklist',
      description: 'Take the quiz',
      display_homepage: true,
      component: eventQuizContainer,
      children: [
        {
          path: '',
          name: 'Professional Learning Readiness Quiz',
          component: eduPdReadinessQuiz
        }
      ]
    },
    {
      path: '/pd-readiness-edu',
      name: 'Education Association Professional Learning Readiness Checklist',
      description: 'Take the quiz',
      display_homepage: true,
      component: eventQuizContainer,
      children: [
        {
          path: '',
          name: 'Professional Learning Readiness Quiz',
          component: eduPdReadinessQuiz
        }
      ]
    },
    {
      path: '/professional-learning-readiness',
      name: 'Professional Learning Readiness Checklist',
      description: 'Take the quiz',
      display_homepage: true,
      component: eventQuizContainer,
      children: [
        {
          path: '',
          name: 'Professional Learning Readiness Quiz',
          component: pdReadinessQuiz
        }
      ]
    },
    {
      path: '/pd-readiness',
      name: 'Professional Learning Readiness Checklist',
      description: 'Take the quiz',
      display_homepage: true,
      component: eventQuizContainer,
      children: [
        {
          path: '',
          name: 'Professional Learning Readiness Quiz',
          component: pdReadinessQuiz
        }
      ]
    },
    {
      path: '/sparking-change',
      name: 'Sparking Change',
      description: 'Whether it’s strengthening the community where you live or supporting people around the world, your organization is on a mission to transform lives. Your learning programs help make that happen.',
      display_homepage: true,
      component: eventQuizContainer,
      children: [
        {
          path: '',
          name: 'Main Learner Type Quiz',
          component: sparkingChangeQuiz
        },
        {
          path: 'leaderboard',
          // redirect: to => {
          //   return { path: '/' };
          // }
          name: 'Learner Type Quiz: Overall Leaderboard',
          component: eventQuizResults
        },
        {
          path: ':eventId',
          name: 'Learner Type Quiz',
          component: learnerType
        },
        {
          path: ':eventId/leaderboard',
          name: 'Learner Type Leaderboard',
          component: eventQuizResults
        },
        {
          path: ':eventId/qr',
          name: 'Link to Event Quiz',
          component: eventQR
        }
      ],
      meta: { version: 2 }
    },
    {
      path: "/learner-type",
      name: "Learner Type",
      description:
        "Find out what your learner type is. Are you a Competitor, Collector, Collaborator, or a Connoisseur? Take the quiz to find out!",
      display_homepage: true,
      component: eventQuizContainer,
      children: [
        {
          path: '',
          name: 'Main Learner Type Quiz',
          component: learnerType,
          meta: { version: 1 }
        },
        {
          path: 'leaderboard',
          // redirect: to => {
          //   return { path: '/' };
          // }
          name: 'Learner Type Quiz: Overall Leaderboard',
          component: eventQuizResults,
          meta: { version: 1 }
        },
        {
          path: ':eventId',
          name: 'Learner Type Quiz',
          component: learnerType,
          meta: { version: 1 }
        },
        {
          path: ':eventId/leaderboard',
          name: 'Learner Type Leaderboard',
          component: eventQuizResults,
          meta: { version: 1 }
        },
        {
          path: ':eventId/qr',
          name: 'Link to Event Quiz',
          component: eventQR,
          meta: { version: 1 }
        }
      ]
    },
    {
      path: "/superhero",
      name: "Fusion Superhero Type",
      description: "Find out what your superhero alias is. Are you a Gadgeteer, TrailBlazer, Cosmic Guardian, or a more secretive Super Agent? Take the quiz to find out!",
      display_homepage: false,
      component: fusionQuiz,
      meta: { version: 1 }
    },
    {
      path: "/imagineer",
      name: "Fusion Imagineer Type",
      description: " Find your inner imagineer. Are you a Researcher, Engager, Innovator, or maybe a technology Imagineer? Take the quiz to find out!",
      display_homepage: false,
      component: fusionImagineerQuiz,
      meta: { version: 1 }
    },
    {
      path: "/resiliency-quiz",
      name: "Resiliency Quiz",
      description: " Take the resiliency quiz here!",
      display_homepage: false,
      component: fusionResiliencyQuiz,
      meta: { version: 1 }
    },
    {
      path: "/animal-type",
      name: "Fusion Canadian Animal Type",
      description: "Take the quiz to find out what Canadian Animal you are.",
      display_homepage: false,
      component: eventQuizContainer,
      meta: { version: 1 },
      children: [ 
        {
          path: ':eventId',
          name: 'Animal Type Quiz',
          component: fusionAnimalQuiz,
          meta: { version: 1 }
        },
        {
          path: ':eventId/leaderboard',
          name: 'Animal Type Leaderboard',
          component: eventQuizResults
        },
        {
          path: ':eventId/qr',
          name: 'Link to Event Quiz',
          component: eventQR
        }
      ]
    }
  ],
});
